const DELIVERY_OPTION_TYPES = {
    SHIPPED: 'shipped',
    SAME_DAY: 'sameDay',
    PICKUP: 'pickup',
    AUTO_REPLENISH: 'autoReplenish'
};

const BOPIS_WARNING_KEY = 'productgraph.liteProduct.bopis.notFound';

const COMPONENT_SIDS = {
    BASKET_YOUR_SAVED_ITEMS_CAROUSEL: 'basket_your_saved_items_carousel'
};

export {
    DELIVERY_OPTION_TYPES,
    BOPIS_WARNING_KEY,
    COMPONENT_SIDS
};
